import React from "react";
import '../../../../styles/component/employee-details/detail-grid.scss';

export interface DetailItem {
    label: string;
    value?: React.ReactNode;
}

interface Props {
    data: DetailItem[];
    columns?: number;
}

const DetailGrid = ({data, columns = 2}: Props) => {
    return (
        <div
            className="detail-grid"
            style={{gridTemplateColumns: `repeat(${columns}, 1fr)`}}
        >
            {data.map((item, index) => (
                <div key={index} className="detail-grid__item">
                    <span className="label">{item.label}</span>
                    <span className="value">{item.value ?? "-"}</span>
                </div>
            ))}
        </div>
    );
};

export default DetailGrid;
